import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { selectors } from 'lib/entities/fundachart';
import { selectors as comparisonSelectors } from 'lib/entities/comparison';
import companyProfile, {
  selectors as companySelectors,
} from 'features/company/slice';

import useStore from './index';
import { CompanyWidgetEnum } from '../constants';
import { SectionEnum } from '../types';

const ERROR = 402;

function useErrorPaywall(activeTab: string, symbol: string) {
  const dispatch = useDispatch();

  const { error } = useSelector(selectors);
  const { error: companyError } = useSelector(companySelectors);
  const { error: comparisonError } = useSelector(comparisonSelectors);

  const resetProStatus = useStore((state) => state.resetProStatus);

  useEffect(() => {
    if (!activeTab || !symbol) return;
    const TAB = activeTab.toUpperCase();

    switch (TAB) {
      case CompanyWidgetEnum.FUNDACHART:
        checkIsError(error);
        break;

      case CompanyWidgetEnum.SEASONALITY:
      case CompanyWidgetEnum.FINANCIALS:
        checkIsError(companyError);
        dispatch(companyProfile.actions.resetErrorState());
        break;

      case CompanyWidgetEnum.COMPARISON:
        checkIsError(comparisonError);
        break;

      default:
        break;
    }
  }, [error, companyError, comparisonError, activeTab, symbol]);

  const checkIsError = (error: any | Error): boolean => {
    if (!error) return false;

    const isError = error.response?.status === ERROR;

    if (isError) {
      resetProStatus(SectionEnum.company);
    }

    return true;
  };

  return { error, companyError, comparisonError };
}

export default useErrorPaywall;
